// extracted by mini-css-extract-plugin
export default {"eventLog":"ErrorLog_eventLog__EMRqv","innerCard":"ErrorLog_innerCard__Gl+KQ"};